module.exports = __webpack_public_path__ + "img/moments.ac901fe7.png";